import React from "react";
import { View, ViewStyle, TextStyle, Text, StyleProp } from "react-native";
import { TouchableOpacity } from ".";
import { bottomButtonStyles as styles } from "./styles";

interface BottomButtonProps {
  onPress: () => void;
  disabled?: boolean;
  buttonText: string;
  styles?: {
    buttonContainer?: StyleProp<ViewStyle>;
    buttonText?: StyleProp<TextStyle>;
  };
}

const BottomButton: React.FC<BottomButtonProps> = ({
  buttonText,
  disabled = false,
  onPress,
  styles: customStyles,
}) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity
        disabled={disabled}
        onPress={onPress}
        style={[
          styles.buttonContainer,
          disabled && styles.disabledStyles,
          customStyles?.buttonContainer,
        ]}
      >
        <Text style={[styles.buttonText, customStyles?.buttonText]}>
          {buttonText}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default BottomButton;
